// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3-8qT","disabled":"FileBtn_disabled__KBe7W","warn":"FileBtn_warn__3eaZC","fade":"FileBtn_fade__CH0Cw"};